export default "__VITE_ASSET__C$fRIemX__"